import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.fileName = ''
      this.fileSuffix = ''
      this.createBy = ''
    }
  }
}
export default searchFrom
